export default __webpack_public_path__ + "media/images/icons/twitter-avatar1-c0893dfd784426c18b6f48f5aba503d0.png";